import {IssueSortingKey} from '@domain/stoppages'
import {MenuItem, TextField} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type SortBySelectProps = {
  value: IssueSortingKey
  onChange: (value: IssueSortingKey) => void
  'data-test-id': string
}

export const SortBySelect: React.FC<SortBySelectProps> = ({
  value,
  onChange,
  'data-test-id': dataTestId
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      id="sort-by-drop-down"
      name="sortBy"
      label={t('actions.sortBy')}
      value={value}
      onChange={(e) => {
        onChange(e.target.value as IssueSortingKey)
      }}
      data-test-id={`${dataTestId}-select`}
    >
      {Object.values(IssueSortingKey).map((key) => (
        <MenuItem key={key} value={key} data-test-id={`${dataTestId}-${key}`}>
          {t(`actions.${key}`)}
        </MenuItem>
      ))}
    </TextField>
  )
}
